// src/services/AllOrdersService.js

import api from './api';

export const fetchAllOrders = async () => {
  try {
    const response = await api.get('/orders/all');
    console.log('[AllOrdersService] Fetched all orders:', response.data);
    return response.data;
  } catch (error) {
    console.error('[AllOrdersService] Error fetching all orders:', error.response?.data || error.message);
    throw error;
  }
};
